var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCreatorPageUspQuoteSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 32,
    viewBox: "0 0 49 32",
    width: 49,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.294 31.941c2.078 0 3.902-.637 5.471-1.912s2.353-2.853 2.353-4.735c0-1.412-.882-4.451-2.647-9.118l-.223-.6c-1.977-5.317-3.079-8.392-3.306-9.223-.941-3.569-3.431-5.353-7.471-5.353-2.118 0-3.941.608-5.471 1.824-1.647 1.255-2.471 2.843-2.471 4.765 0 1.608.863 4.784 2.588 9.529 1.255 3.333 2.49 6.637 3.706 9.912s3.706 4.912 7.471 4.912zm-25.353-.176c2.118 0 3.961-.637 5.529-1.912s2.353-2.853 2.353-4.735c0-.196-.882-3.02-2.647-8.471s-2.804-8.608-3.118-9.471c-1.176-3.216-3.588-4.824-7.235-4.824-2.078 0-3.902.608-5.471 1.824-1.686 1.255-2.529 2.843-2.529 4.765 0 .902.882 4.02 2.647 9.353 1.647 5.02 2.765 8.118 3.353 9.294 1.373 2.784 3.745 4.176 7.118 4.176z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatorPageUspQuoteSvg);
export default __webpack_public_path__ + "static/media/CreatorPageUspQuoteSvg.8c43038f3e1e7e5bc0ab344e88691f79.svg";
export { ForwardRef as ReactComponent };